import { render, staticRenderFns } from "./TicketEditTabSolutions.vue?vue&type=template&id=097a7377"
import script from "./TicketEditTabSolutions.vue?vue&type=script&lang=js"
export * from "./TicketEditTabSolutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports